import { render, staticRenderFns } from "./RestaurantCard.vue?vue&type=template&id=ce026348&scoped=true&"
import script from "./RestaurantCard.vue?vue&type=script&lang=js&"
export * from "./RestaurantCard.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantCard.vue?vue&type=style&index=0&id=ce026348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce026348",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VImg,VRating})
